import { CursorPaginationResult } from "@/types/CursorPaginationResult";
import { useMemo } from "react";
import { InfiniteData } from "react-query";

export function useInifiniteDatas<V>(pages?: InfiniteData<CursorPaginationResult<V>>) {
  return {
    count: useMemo(() => pages?.pages[0].count, [pages?.pages]),
    datas: useMemo(() => pages?.pages.flatMap((page) => page.results), [pages]),
  };
}
